import { render } from "./FileSpecifications.vue?vue&type=template&id=63802636&scoped=true"
import script from "./FileSpecifications.vue?vue&type=script&lang=js"
export * from "./FileSpecifications.vue?vue&type=script&lang=js"

import "./FileSpecifications.vue?vue&type=style&index=0&id=63802636&scoped=true&lang=css"

import exportComponent from "/Users/bobbarnard/Documents/sources/bungalow7-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63802636"]])

export default __exports__